import React from "react";
import { Card, Col, Row, Statistic, Table } from "antd";
import {
  ShoppingCartOutlined,
  AppstoreOutlined,
  UserOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import "./AdminDashboard.css";

// Podaci za grafikon prodaje
const salesData = [
  { mesec: "Jan", prihod: 12000 },
  { mesec: "Feb", prihod: 15000 },
  { mesec: "Mar", prihod: 18000 },
  { mesec: "Apr", prihod: 22000 },
  { mesec: "Maj", prihod: 25000 },
];

// Podaci za najprodavanije proizvode
const topProducts = [
  { key: "1", naziv: "iPhone 13", prodato: 150 },
  { key: "2", naziv: "Samsung Galaxy S22", prodato: 130 },
  { key: "3", naziv: "MacBook Air", prodato: 95 },
  { key: "4", naziv: "Sony PS5", prodato: 85 },
];

const Dashboard = () => {
  return (
    <div className="admin-dashboard">
      <h2 className="dashboard-title">Dobrodošli u Admin Panel</h2>

      {/* Statistika */}
      <Row gutter={16}>
        <Col span={6}>
          <Card bordered={false}>
            <Statistic
              title="Ukupno proizvoda"
              value={120}
              prefix={<AppstoreOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false}>
            <Statistic
              title="Ukupno porudžbina"
              value={325}
              prefix={<ShoppingCartOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false}>
            <Statistic
              title="Ukupno korisnika"
              value={560}
              prefix={<UserOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false}>
            <Statistic
              title="Ukupni prihod"
              value={"150,000 RSD"}
              prefix={<DollarOutlined />}
            />
          </Card>
        </Col>
      </Row>

      {/* Grafikon prodaje */}
      <Card title="Prihod po mesecima" style={{ marginTop: 20 }}>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={salesData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="mesec" />
            <YAxis />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="prihod"
              stroke="#2e9900"
              strokeWidth={3}
            />
          </LineChart>
        </ResponsiveContainer>
      </Card>

      {/* Tabela najprodavanijih proizvoda */}
      <Card title="Najprodavaniji proizvodi" style={{ marginTop: 20 }}>
        <Table
          columns={[
            { title: "Proizvod", dataIndex: "naziv", key: "naziv" },
            { title: "Prodato komada", dataIndex: "prodato", key: "prodato" },
          ]}
          dataSource={topProducts}
          pagination={false}
        />
      </Card>
    </div>
  );
};

export default Dashboard;
